import { render, staticRenderFns } from "./EvaluacionRendimientoProfesionalismoDialogComponent.vue?vue&type=template&id=2f9a60aa&scoped=true"
import script from "./EvaluacionRendimientoProfesionalismoDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionRendimientoProfesionalismoDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionRendimientoProfesionalismoDialogComponent.vue?vue&type=style&index=0&id=2f9a60aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9a60aa",
  null
  
)

export default component.exports